var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.5,17.5H4.167A1.667,1.667,0,0,1,2.5,15.833V4.167A1.667,1.667,0,0,1,4.167,2.5H7.5",
    transform: "translate(-4 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.333,14.167,17.5,10,13.333,5.833",
    transform: "translate(-4 -7)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 10,
    transform: "translate(3.5 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5f59e81e8f68f1e68a70cdd6c3cdc8c9.svg";
export { ForwardRef as ReactComponent };